import { render, staticRenderFns } from "./LoginLiteToken.vue?vue&type=template&id=157c6b4a"
import script from "./LoginLiteToken.vue?vue&type=script&lang=js"
export * from "./LoginLiteToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports